<template>
  <div class="recharge-record-section">
    <!-- 条件搜索 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="手机号" prop="mobile">
              <a-input
                v-model="mobile"
                placeholder="请输入手机号"
                allow-clear
                @pressEnter="handleQuery"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="会员姓名" prop="memberName">
              <a-input
                v-model="memberName"
                placeholder="请输入会员姓名"
                allow-clear
                @pressEnter="handleQuery"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="充值时间" prop="dateRange">
              <a-range-picker
                v-model="dateRange"
                @change="handleDateChange"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery">
                <a-icon type="search" />查询
              </a-button>
              <a-button style="margin-left: 8px" @click="resetQuery">
                <a-icon type="redo" />重置
              </a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      :columns="columns"
      :data-source="rechargeList"
      :pagination="pagination"
      @change="handleTableChange"
      :loading="loading"
      rowKey="id"
    >
      <template slot="amount" slot-scope="text">
        <span :style="{ color: parseFloat(text) > 0 ? '#52c41a' : '#cf1322' }">
          {{ parseFloat(text) > 0 ? '+' : '' }}¥{{ parseFloat(text).toFixed(2) }}
        </span>
      </template>
      <template slot="payType" slot-scope="text">
        <a-tag :color="getPayTypeColor(text)">
          {{ getPayTypeText(text) }}
        </a-tag>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a v-if="parseFloat(record.amount) > 0" @click="handleRefundRecharge(record)">
          <a-icon type="undo" />退充值
        </a>
        <span v-else style="color: #999">不可退款</span>
      </template>
    </a-table>

    <!-- 退充值弹窗 -->
    <a-modal
      :visible="refundModalVisible"
      title="退充值"
      @cancel="closeRefundModal"
      :maskClosable="false"
      width="500px"
    >
      <a-form-model
        ref="refundForm"
        :model="refundForm"
        :rules="refundRules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
      >
        <a-form-model-item label="会员姓名">
          <span>{{ currentRefundRecord?.memberName || '-' }}</span>
        </a-form-model-item>
        <a-form-model-item label="手机号">
          <span>{{ currentRefundRecord?.memberPhone || '-' }}</span>
        </a-form-model-item>
        <a-form-model-item label="充值金额">
          <span style="color: #52c41a; font-weight: 600">¥{{ parseFloat(currentRefundRecord?.amount || 0).toFixed(2) }}</span>
        </a-form-model-item>
        <a-form-model-item label="到账金额">
          <span>¥{{ parseFloat(currentRefundRecord?.arrivalAmount || 0).toFixed(2) }}</span>
        </a-form-model-item>
        <a-form-model-item label="已退款金额">
          <span style="color: #ff4d4f">-¥{{ parseFloat(currentRefundRecord?.refundAmount || 0).toFixed(2) }}</span>
        </a-form-model-item>
        <a-form-model-item label="退款金额" prop="refundAmount">
          <a-input-number
            v-model="refundForm.refundAmount"
            :min="0"
            :max="parseFloat(currentRefundRecord?.arrivalAmount || 0) - parseFloat(currentRefundRecord?.refundAmount || 0)"
            :precision="2"
            placeholder="请输入退款金额"
            style="width: 100%"
          />
          <div style="margin-top: 8px; color: #999; font-size: 12px">
            最大可退款金额：¥{{ (parseFloat(currentRefundRecord?.arrivalAmount || 0) - parseFloat(currentRefundRecord?.refundAmount || 0)).toFixed(2) }}
          </div>
        </a-form-model-item>
        <a-form-model-item label="退款原因" prop="reason">
          <a-textarea
            v-model="refundForm.reason"
            placeholder="请输入退款原因"
            :rows="3"
            :maxLength="200"
          />
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button @click="closeRefundModal">取消</a-button>
        <a-button type="primary" :loading="refundLoading" @click="handleConfirmRefund">确认退款</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { getRechargeList, refundRecharge } from '@/api/retail/recharge'

export default {
  name: 'RechargeRecord',
  data() {
    return {
      rechargeList: [],
      loading: false,
      mobile: '',
      memberName: '',
      dateRange: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      // 退充值相关
      refundModalVisible: false,
      refundLoading: false,
      currentRefundRecord: null,
      refundForm: {
        refundAmount: 0,
        reason: ''
      },
      refundRules: {
        refundAmount: [
          { required: true, message: '请输入退款金额', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '退款金额必须大于0', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '请输入退款原因', trigger: 'blur' }
        ]
      },
      columns: [
        { title: '会员姓名', dataIndex: 'memberName', width: 120, align: 'center' },
        { title: '手机号', dataIndex: 'memberPhone', width: 130, align: 'center' },
        { title: '充值金额', dataIndex: 'amount', width: 120, align: 'center', scopedSlots: { customRender: 'amount' } },
        { title: '到账金额', dataIndex: 'arrivalAmount', width: 120, align: 'center', customRender: (text) => `¥${parseFloat(text || 0).toFixed(2)}` },
        { title: '支付方式', dataIndex: 'payType', width: 120, align: 'center', scopedSlots: { customRender: 'payType' } },
        { title: '充值时间', dataIndex: 'createTime', width: 180, align: 'center' },
        { title: '退款金额', dataIndex: 'refundAmount', width: 120, align: 'center', customRender: (text) => text ? `-¥${parseFloat(text).toFixed(2)}` : '-' },
        { title: '操作', dataIndex: 'operation', width: 120, align: 'center', fixed: 'right', scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  mounted() {
    this.loadRechargeList()
  },
  methods: {
    async loadRechargeList() {
      try {
        this.loading = true
        const params = {
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize
        }
        if (this.mobile && this.mobile.trim()) {
          params.mobile = this.mobile.trim()
        }
        if (this.memberName && this.memberName.trim()) {
          params.memberName = this.memberName.trim()
        }
        if (this.dateRange && this.dateRange.length === 2) {
          params.startTime = this.dateRange[0].format('YYYY-MM-DD 00:00:00')
          params.endTime = this.dateRange[1].format('YYYY-MM-DD 23:59:59')
        }
        const response = await getRechargeList(params)
        if (response.code == 20001 && response.data) {
          this.rechargeList = response.data.records || []
          this.pagination.total = response.data.total || 0
        }
      } catch (error) {
        this.$message.error('加载充值记录失败')
      } finally {
        this.loading = false
      }
    },
    handleDateChange() {
      // 日期改变不立即搜索，需要点击查询按钮
    },
    handleQuery() {
      this.pagination.current = 1
      this.loadRechargeList()
    },
    resetQuery() {
      this.mobile = ''
      this.memberName = ''
      this.dateRange = []
      this.pagination.current = 1
      this.loadRechargeList()
    },
    handleTableChange(pagination) {
      this.pagination = { ...this.pagination, ...pagination }
      this.loadRechargeList()
    },
    getPayTypeColor(payType) {
      const colorMap = {
        2: '#09bb07', // 微信
        1: '#1677ff', // 支付宝
        10: '#ff9800', // 现金
        11: '#722ed1', // 人民币支票
        12: '#eb2f96'  // 人民币信用卡
      }
      return colorMap[payType] || 'default'
    },
    getPayTypeText(payType) {
      const textMap = {
        2: '微信',
        1: '支付宝',
        10: '现金',
        11: '人民币支票',
        12: '人民币信用卡'
      }
      return textMap[payType] || '-'
    },
    // 打开退充值弹窗
    handleRefundRecharge(record) {
      this.currentRefundRecord = record
      // 最大可退款金额 = 到账金额 - 已退款金额
      const maxRefundAmount = parseFloat(record.arrivalAmount || 0) - parseFloat(record.refundAmount || 0)
      this.refundForm = {
        refundAmount: maxRefundAmount > 0 ? maxRefundAmount : 0,
        reason: ''
      }
      this.refundModalVisible = true
    },
    // 关闭退充值弹窗
    closeRefundModal() {
      this.refundModalVisible = false
      this.currentRefundRecord = null
      this.refundForm = {
        refundAmount: 0,
        reason: ''
      }
      this.$refs.refundForm?.resetFields()
    },
    // 确认退充值
    async handleConfirmRefund() {
      try {
        await this.$refs.refundForm.validate()
      } catch (error) {
        return
      }

      this.$confirm({
        title: '确认退充值',
        content: `确认要退款 ¥${this.refundForm.refundAmount.toFixed(2)} 给 ${this.currentRefundRecord.memberName} 吗？`,
        onOk: async () => {
          try {
            this.refundLoading = true
            const params = {
              rechargeId: this.currentRefundRecord.id,
              refundAmount: this.refundForm.refundAmount,
              reason: this.refundForm.reason
            }
            const response = await refundRecharge(params)
            if (response.code == 20001 || response.success) {
              this.$message.success('退充值成功')
              this.closeRefundModal()
              this.loadRechargeList()
            } else {
              this.$message.error(response.msg || '退充值失败')
            }
          } catch (error) {
            this.$message.error('退充值失败，请重试')
          } finally {
            this.refundLoading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.recharge-record-section {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: #f0f2f5;

  .table-page-search-wrapper {
    margin-bottom: 16px;
    padding: 24px 24px 0 24px;
    background: #fff;
    border-radius: 4px;

    .table-page-search-submitButtons {
      display: block;
      white-space: nowrap;
    }
  }
}
</style>
